import React, { useEffect, useRef, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { MwInputText, MwSpinnerButton } from "./ui";
import axios from "axios";
import { useCurrent } from "../hooks";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SearchVendor = ({ className, onChangeSearch = () => {}, isOpen = true }) => {
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangId } = useCurrent();
  const token = localStorage.getItem("token");
  const [t] = useTranslation("global");

  const params = useParams();
  const [term, setTerm] = useState("");
  const [dataResult, setDataResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const prevTermRef = useRef("");
  const onChangeHandler = (e) => {
    setTerm(e.target.value);
  };

  const getResult = async () => {
    isOpen && setShow(true);
    setLoading(true);
    const response = await axios.get(
      `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/name/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${term}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const result = response?.data?.data;
    setLoading(false);
    setDataResult(result);
    onChangeSearch(result);
  };

  useEffect(() => {
    if (!term) {
      setShow(false);
      if (prevTermRef.current) {
        onChangeSearch([]);
      }
      prevTermRef.current = "";
      return;
    }

    prevTermRef.current = term;
    const timeout = setTimeout(() => {
      getResult();
    }, 600);

    return () => {
      clearTimeout(timeout);
    };
  }, [term]);

  return (
    <div className=" flex-1">
      <div onClick={() => term && setShow(!show)} className={` relative ${show && "border-t border-s border-e rounded-lg"} `}>
        <BiSearch className="absolute top-2 start-3" size={16} />
        <MwInputText
          classNameInput={`bg-slate-50 rounded-lg ${className}`}
          placeholder={t("vendors.searchVendor")}
          value={term}
          onChange={onChangeHandler}
        />
      </div>
      {show && (
        <div className={` absolute z-50  top-9 w-3/6 overflow-y-auto h-48 border-b border-s border-e  bg-slate-50  rounded-b-lg opacity-95 ${"block"}`}>
          {!loading ? (
            dataResult.length > 0 ? (
              <ul>
                <li className="flex justify-between p-2 text-xs border-b">
                  <div className="w-24 px-1 text-center">{t("vendors.vendorNumber")}</div>
                  <div className="flex-1">{t("vendors.vendorName")}</div>
                </li>
                {dataResult.map((result) => (
                  <Link
                    target="_blank"
                    to={`/${params.tenant}/vendors/show/${result?._id}/${result?.companyId}/${result?.branchId}`}
                    key={result._id}
                  >
                    <li className=" flex justify-between p-2 text-xs border-b hover:bg-indigo-50 hover:font-bold">
                      <div className="w-24 px-1  text-center">{result.vendorNo || ""}</div>
                      <div className="flex-1">
                        {result?.fullname?.find((item) => item.lang === currentLangId)?.text ||
                          result?.fullname?.[0]?.text ||
                          ""}
                      </div>
                    </li>
                  </Link>
                ))}
              </ul>
            ) : (
              <div className="text-center p-5">{t("vendors.noResults")}</div>
            )
          ) : (
            <MwSpinnerButton withLabel={false} isFullCenter={true} />
          )}
        </div>
      )}
    </div>
  );
};

export default SearchVendor;
